module.exports = __webpack_public_path__ + "img/xzpc.5f219a08.png";